if (!customElements.get('sticky-bar')) {
  class StickyBar extends HTMLElement {
    static Selectors = {
      parentSection: '.product-section',
      image: '[js-image] img',
      price: '.js-price',
      button: '[js-button]',
      targetButton: '[name="add"]'
    }

    constructor() {
      super();
    }

    initObserver() {
      if(!this.targetButton) return;

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting)
        },
        {
          root: null,
          threshold: 1
        }
      );
    
      this.observer.observe(this.targetButton);
    }

    handleButtonClick(event) {
      event.preventDefault();

      this.targetButton.click();
    }

    initButton() {
      if(!this.button || !this.targetButton) return;

      this.button.addEventListener('click', this.handleButtonClick.bind(this));
    }

    handleButtonUpdate(event) {
      if(!this.button) return;

      const { disable, text } = event.detail;
      
      if (disable) {
        this.button.setAttribute('disabled', 'disabled')
        if (text) this.button.textContent = text
      } else {
        this.button.removeAttribute('disabled')
        this.button.textContent = window.variantStrings.addToCart
      }
    }

    updateImage(image) {
      if(!image) return;


    }

    updatePrice(price) {
      if(!price) return;

      this.price.innerHTML = price.innerHTML;
    }

    handleVariantChange(event) {
      const featured_image = event.detail.variant.featured_image;
      const price = event.detail.price;
      console.log(price);

      this.updateImage(featured_image);
      this.updatePrice(price);
    }

    handleScroll() {
      const isAtBottom = document.body.clientHeight <= window.scrollY + window.innerHeight + 100;
      this.classList.toggle('at-bottom', isAtBottom);
    }

    init() {
      this.initObserver();
      this.initButton();

      document.addEventListener('sticky-bar:button', this.handleButtonUpdate.bind(this));
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
      document.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    }

    connectedCallback() {
      this.parentSection = document.querySelector(StickyBar.Selectors.parentSection);
      this.image = this.querySelector(StickyBar.Selectors.image);
      this.price = this.querySelector(StickyBar.Selectors.price);
      this.button = this.querySelector(StickyBar.Selectors.button);
      this.targetButton = document.querySelector(StickyBar.Selectors.targetButton);

      this.init();
    }
  }

  customElements.define('sticky-bar', StickyBar);
}